export default "assets/7186574729c5671595f7fc43f898d39b.png";